"use client";

import { Col, Container, Row } from "react-bootstrap";
import "./AIImpactSection.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import Image from "next/image";
import ContactFormModal from "@/components/ContactFormModal/ContactFormModal";
import { useState } from "react";
import Button from "@/components/Button/Button";
import FeatureSliderSection from "@/components/FeatureSliderSection/FeatureSliderSection";

const AIImpactSection = ({ impact }) => {
  if (!impact) return null;

  const { title, description, cases = [], buttonText } = impact;

  return (
    <FeatureSliderSection
      title={title}
      description={description}
      items={cases}
      buttonText={buttonText}
    />
  );
};

export default AIImpactSection;
